/* eslint-disable */
import { useMemo } from 'react';
import MeasurementBox from './MeasurementBox';
import styles from './Measurement.module.css';
import { classes, getHigherUnitAndQuantity } from '../../../../Helpers';

function Measurement(props) {
	const {
		temp, weight, className, isEdit = false, updateValue = null, handleValue = () => { },
	} = props;

	const processedWeight = useMemo(() => {
		if (!weight) return weight;

		const processedMeasurements = weight?.measurement?.map((obj) => {
			const rawVal = obj?.rawValue;
			if (weight?.unit.toLowerCase() === 'kg') {
				const [displayValue, displayUnit] = getHigherUnitAndQuantity('g', rawVal);
				return {
					...obj,
					displayValue,
					displayUnit,
				};
			}
			const [displayValue, displayUnit] = getHigherUnitAndQuantity(weight?.unit || 'g', rawVal);

			return {
				...obj,
				displayValue,
				displayUnit,
			};
		});

		return {
			...weight,
			measurement: processedMeasurements,
		};
	}, [weight]);

	return (
		<div className={classes(className, styles.root)}>
			{(
				(!String(temp?.measurement?.[0]?.value).startsWith('120') && !String(temp?.measurement?.[0]?.value).startsWith('125')) &&
				(!String(temp?.measurement?.[1]?.value).startsWith('120') && !String(temp?.measurement?.[1]?.value).startsWith('125')) &&
				temp?.measurement?.[0]?.rawValue !== null
			) && (
					<MeasurementBox temp measurements={temp} />
				)}

			<MeasurementBox
				weight
				measurements={processedWeight}
				isEdit={isEdit}
				updateValue={updateValue}
				handleUpdateValue={handleValue}
			/>
		</div>
	);
}

Measurement.defaultProps = {
	temp: {
		min: 0,
		max: 0,
		title: 'Temperature',
		measurement: [],
		result: null,
	},
	weight: {
		min: 0,
		max: 0,
		title: 'Weight',
		measurement: [],
		result: null,
	},
	className: '',
};

export default Measurement;
